export const AmountWidget = ({ value }) => {
  var fixed = (value / 100).toFixed(2)
  return <div>{fixed} zł</div>
}
